/**
 * 结算抽屉
 */
import React, { useImperativeHandle, useRef } from 'react';

import BillSettle from '@/pages/bill/settle';
import { SettleDrawerRef as InnerSettleRef } from '@/pages/bill/interface';

export interface SettleDrawerRef {
  // 主单号 回调
  showDrawer: (orderNo: string, callback?: () => void) => void;
}

interface IProps {
  myRef?: React.Ref<SettleDrawerRef>;
}

const Index: React.FC<IProps> = (props) => {
  const settleDrawerRef = useRef<InnerSettleRef>(null);
  const configRef = useRef<() => void>(() => {});

  // ref引用
  useImperativeHandle(
    props.myRef,
    () => ({
      showDrawer: (orderNo, callback) => {
        settleDrawerRef.current.openDrawer({ resvNo: orderNo });
        configRef.current = callback;
      },
    }),
    [],
  );

  // 结算回调
  const settleCallback = () => {
    const callbackHandler = configRef.current;
    if (typeof callbackHandler === 'function') {
      callbackHandler();
    }
  };

  return <BillSettle ref={settleDrawerRef} settleCallback={settleCallback} />;
};

export default React.forwardRef<SettleDrawerRef>((props, ref) => <Index {...props} myRef={ref} />);
